/**
 * <s-rewards-bar> wraps the VIP rewards <details> disclosure and lets a close
 * button inside the open panel collapse it, returning focus to the summary.
 */
class SRewardsBar extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.closeButton = this.querySelector('[data-rewards-close]');
    if (!this.details || !this.closeButton) return;
    this.handleClose = () => {
      this.details.open = false;
      this.details.querySelector('summary')?.focus();
    };
    this.closeButton.addEventListener('click', this.handleClose);
  }

  disconnectedCallback() {
    this.closeButton?.removeEventListener('click', this.handleClose);
  }
}

if (!customElements.get('s-rewards-bar')) {
  customElements.define('s-rewards-bar', SRewardsBar);
}
